import request from '@/utils/request'

// 查询合同管理列表
export function listNoContract(query) {
  return request({
    url: '/cont/nocontract/list',
    method: 'get',
    params: query
  })
}

// 查询合同管理详细
export function getNoContract(contractId) {
  return request({
    url: '/cont/nocontract/' + contractId,
    method: 'get'
  })
}

// 新增合同管理
export function addContract(data) {
  return request({
    url: '/cont/nocontract',
    method: 'post',
    data: data
  })
}

// 修改合同管理
export function updateNoContract(data) {
  return request({
    url: '/cont/nocontract',
    method: 'put',
    data: data
  })
}

// 删除合同管理
export function delContract(contractId) {
  return request({
    url: '/cont/nocontract/' + contractId,
    method: 'delete'
  })
}

// 导出合同管理
export function exportContract(query) {
  return request({
    url: '/cont/nocontract/export',
    method: 'get',
    params: query
  })
}

// 审核合同管理
export function verifyContract(data) {
  return request({
    url: '/cont/nocontract/verify',
    method: 'put',
    data: data
  })
}